import { Routes } from '@angular/router';
// Third party packages
// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';
// Custom packages - Component
import { GenericDocsListComponent } from './pages/generic-docs-list.page';
var ɵ0 = {
    permissions: []
};
var routes = [
    {
        path: 'list',
        component: GenericDocsListComponent,
        canActivate: [RoleGuard],
        data: ɵ0,
    },
    {
        path: '**',
        redirectTo: 'it/errors/404'
    }
];
var GenericDocsRoutingModule = /** @class */ (function () {
    function GenericDocsRoutingModule() {
    }
    return GenericDocsRoutingModule;
}());
export { GenericDocsRoutingModule };
export { ɵ0 };
